import { Player } from "./match-detail"

export enum MatchStat {
  PAYMENT_MISSING = "payment-missing",
  MATCH_READY_TO_PLAY = "match-ready-to-play",
  IN_PROGRESS = "in-progress",
  PLAYER_IDENTIFICATION_MISSING = "player-identification-missing",
  AVAILABLE = "available",
  OTHERS_PAYMENT_MISSING = "others-payment-missing",
}
export class Match {
  constructor(
    readonly code: string,
    readonly date: Date,
    readonly club: string,
    readonly curt: string,
    readonly matchStat: MatchStat,
    readonly victory: string | null,
    readonly payment_done: boolean,
    readonly reservationId: string | null,
    readonly shareable: boolean,
    readonly players: Player[],
    readonly customName: string | null
  ) {}
}

export type MatchFilters = {
  search: string | null,
  date_from: string | null,
  date_to: string | null,
  result: string[] | null,
  club: string[] | null,
  order: string | null
}